import {
  GET_STOCK_TAKE,  GET_STOCK_TAKE_COMPLETED, GET_STOCK_TAKE_FAILED,
  START_STOCK_TAKE, START_STOCK_TAKE_COMPLETED, START_STOCK_TAKE_FAILED,
  SEARCH_STOCK_TAKES, SEARCH_STOCK_TAKES_COMPLETED, SEARCH_STOCK_TAKES_FAILED,
  TAKE_STOCK_TAKE, TAKE_STOCK_TAKE_COMPLETED, TAKE_STOCK_TAKE_FAILED,
  GET_STOCK_TAKE_STOCK, GET_STOCK_TAKE_STOCK_COMPLETED, GET_STOCK_TAKE_STOCK_FAILED, CLEAR_STOCK_TAKE_STOCK,
  SEARCH_STOCK_TAKE_DISCREPANCIES, SEARCH_STOCK_TAKE_DISCREPANCIES_COMPLETED, SEARCH_STOCK_TAKE_DISCREPANCIES_FAILED,
  SEARCH_STOCK_TAKE_PRODUCTS, SEARCH_STOCK_TAKE_PRODUCTS_COMPLETED, SEARCH_STOCK_TAKE_PRODUCTS_FAILED,
  ADJUST_STOCKS, ADJUST_STOCK_COMPLETED, ADJUST_STOCK_FAILED,
  END_STOCK_TAKE, END_STOCK_TAKE_COMPLETED, END_STOCK_TAKE_FAILED,
  GET_STOCK_TAKE_COUNTS, GET_STOCK_TAKE_COUNTS_COMPLETED, GET_STOCK_TAKE_COUNTS_FAILED,
  GET_STOCK_TAKE_HISTORY, GET_STOCK_TAKE_HISTORY_COMPLETED, GET_STOCK_TAKE_HISTORY_FAILED,
} from "./actions";
import {AUTH_LOGOUT} from "../Auth/actions";
import {handleSearch, handleSearchCompleted, handleSearchFailed, searchDefault} from "../utils/search";

const defaultState = {
  stockTakes: [],
  stockTakesLoading: false,
  stockTakesError: null,
  stockTake: null,
  stockTakeLoading: false,
  stockTakeError: null,
  startingStockTake: false,
  search: searchDefault,
  takingStockTake: false,
  stock: null,
  gettingStock: false,
  searchDiscrepancies: searchDefault,
  searchProducts: searchDefault,
  adjustingStocks: {
    inProgress: false,
    left: [],
    done: [],
    errors: [],
  },
  endingStockTake: false,
  gettingStockTakeCounts: false,
  stockTakeCounts: [],
  searchHistory: searchDefault,
};

const stockTakeReducer = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case SEARCH_STOCK_TAKES: return handleSearch(state, 'search', action.payload);
    case SEARCH_STOCK_TAKES_COMPLETED: return handleSearchCompleted(state, 'search', action.payload);
    case SEARCH_STOCK_TAKES_FAILED: return handleSearchFailed(state, 'search', action.payload);
    case GET_STOCK_TAKE: {
      return {
        ...state,
        stockTakeLoading: true,
        stockTake: null,
        stockTakeError: null,
      };
    }
    case GET_STOCK_TAKE_COMPLETED: {
      return {
        ...state,
        stockTakeLoading: false,
        stockTake: action.payload,
      };
    }
    case GET_STOCK_TAKE_FAILED: {
      return {
        ...state,
        stockTakeLoading: false,
        stockTakeError: action.payload,
      };
    }
    case START_STOCK_TAKE: {
      return {
        ...state,
        startingStockTake: true,
      };
    }
    case START_STOCK_TAKE_COMPLETED: {
      return {
        ...state,
        startingStockTake: false,
      };
    }
    case START_STOCK_TAKE_FAILED: {
      return {
        ...state,
        startingStockTake: false,
      };
    }
    case TAKE_STOCK_TAKE: {
      return {
        ...state,
        takingStockTake: true,
      };
    }
    case TAKE_STOCK_TAKE_COMPLETED: {
      return {
        ...state,
        takingStockTake: false,
      };
    }
    case TAKE_STOCK_TAKE_FAILED: {
      return {
        ...state,
        takingStockTake: false,
      };
    }
    case GET_STOCK_TAKE_STOCK: {
      return {
        ...state,
        gettingStock: true,
        stock: null,
      };
    }
    case GET_STOCK_TAKE_STOCK_COMPLETED: {
      return {
        ...state,
        gettingStock: false,
        stock: action.payload,
      };
    }
    case GET_STOCK_TAKE_STOCK_FAILED: {
      return {
        ...state,
        gettingStock: false,
      };
    }
    case CLEAR_STOCK_TAKE_STOCK: {
      return {
        ...state,
        stock: null,
      };
    }
    case SEARCH_STOCK_TAKE_DISCREPANCIES: return handleSearch(state, 'searchDiscrepancies', action.payload);
    case SEARCH_STOCK_TAKE_DISCREPANCIES_COMPLETED: return handleSearchCompleted(state, 'searchDiscrepancies', action.payload);
    case SEARCH_STOCK_TAKE_DISCREPANCIES_FAILED: return handleSearchFailed(state, 'searchDiscrepancies', action.payload);
    case SEARCH_STOCK_TAKE_PRODUCTS: return handleSearch(state, 'searchProducts', action.payload);
    case SEARCH_STOCK_TAKE_PRODUCTS_COMPLETED: return handleSearchCompleted(state, 'searchProducts', action.payload);
    case SEARCH_STOCK_TAKE_PRODUCTS_FAILED: return handleSearchFailed(state, 'searchProducts', action.payload);
    case ADJUST_STOCKS: {
      return {
        ...state,
        adjustingStocks: {
          inProgress: true,
          left: action.payload.map(({key}) => key),
          done: [],
          errors: [],
        }
      };
    }
    case ADJUST_STOCK_COMPLETED: {
      const {left, done, errors} = state.adjustingStocks;
      return {
        ...state,
        adjustingStocks: {
          inProgress: left.length > 1,
          left: left.filter(key => key !== action.key),
          done: [...done, action.key],
          errors,
        }
      };
    }
    case ADJUST_STOCK_FAILED: {
      const {left, done, errors} = state.adjustingStocks;
      return {
        ...state,
        adjustingStocks: {
          inProgress: left.length > 1,
          left: left.filter(key => key !== action.key),
          done,
          errors: [...errors, {key: action.key, error: action.payload}],
        }
      };
    }
    case END_STOCK_TAKE: {
      return {
        ...state,
        endingStockTake: true,
      };
    }
    case END_STOCK_TAKE_COMPLETED: {
      return {
        ...state,
        endingStockTake: false,
      };
    }
    case END_STOCK_TAKE_FAILED: {
      return {
        ...state,
        endingStockTake: false,
      };
    }
    case GET_STOCK_TAKE_COUNTS: {
      return {
        ...state,
        gettingStockTakeCounts: true,
        stockTakeCounts: [],
      };
    }
    case GET_STOCK_TAKE_COUNTS_COMPLETED: {
      return {
        ...state,
        gettingStockTakeCounts: false,
        stockTakeCounts: action.payload.data,
      };
    }
    case GET_STOCK_TAKE_COUNTS_FAILED: {
      return {
        ...state,
        gettingStockTakeCounts: false,
      };
    }
    case GET_STOCK_TAKE_HISTORY: return handleSearch(state, 'searchHistory', action.payload);
    case GET_STOCK_TAKE_HISTORY_COMPLETED: return handleSearchCompleted(state, 'searchHistory', action.payload);
    case GET_STOCK_TAKE_HISTORY_FAILED: return handleSearchFailed(state, 'searchHistory', action.payload);
    case AUTH_LOGOUT: {
      return defaultState;
    }
    default:
      return state;
  }
};

export default stockTakeReducer;



// WEBPACK FOOTER //
// ./src/StockTake/reducer.js